module.exports = __webpack_public_path__ + "media/images/avatar/usa-flag-106779e7d2a0686a9fb2c89595c9264e.png";